import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../modules/layout/components/ToastContext';
import { useNavigate } from 'react-router-dom';
import { update } from '../_request';

interface ChangeFullNameProps {
  targetProfileId: string;
  onSuccess: () => void;
}

export default function ChangeFullName({ targetProfileId, onSuccess }: ChangeFullNameProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleChangeFullName = async () => {
    setLoading(true);
    try {
      const result: any = await update(
        `/api/UserEvents/changefullname?targetProfileId=${encodeURIComponent(targetProfileId)}`, 
        null
      );           
      
      const respStatus = result?.status ?? result?.response?.status;     

      if (respStatus === 200 || respStatus === 204 || respStatus === undefined) {
        showToast && showToast(t('FullNameUpdatedSuccessfully'), 'success');
        onSuccess(); 
      } else if (respStatus === 401) {
        navigate('/auth/login');
      } else if (respStatus === 403) {
        navigate('/error/403');
      } else {
        showToast && showToast(t('ErrorUpdatingName'), 'error');
      }
    } catch (err: any) {
      console.error(err);
      showToast && showToast(t('ConnectionError'), 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button 
      className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2" 
      onClick={handleChangeFullName}
      disabled={loading}
      style={{ borderRadius: '20px', padding: '0.25rem 0.75rem' }}
    >
      {loading ? (
        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      ) : (
        <i className="bi bi-arrow-repeat"></i>
      )}
      {loading ? t('Updating') : t('UpdateName')}
    </button>
  );
}